import api from './api';

export const getChiSoDefinitions = async () => {
    return api.get('/chiso/definitions');
};

export const getChiSoValue = async (id: number, fromDate: string, toDate: string) => {
    return api.get(`/chiso/${id}/value`, {
        params: { fromDate, toDate }
    });
};
